<template>
  <v-dialog v-model="editDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-user-friends</v-icon>
              <span class="px-3">{{ $t('Edit Supplier Information') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap>
            <v-flex xs12 sm8 class="pa-2">
              <v-text-field
                v-model="supplierInfo.vender_name"
                :label="`${$t('Supplier Name')} *`"
                name="vender_name"
                box
                hide-details
                background-color="white"
                :error="errors.has('vender_name')"
                v-validate="'required'"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pa-2">
              <v-autocomplete
                v-model="supplierInfo.individual_or_company"
                :items="supplierTypeList"
                :label="`${$t('Type')}`"
                box
                hide-details
                background-color="white"
                :error="errors.has('individual or company')"
                data-vv-name="individual or company"
                :menu-props="{ transition: 'slide-y-transition' }"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pa-2">
              <v-text-field
                v-model="supplierInfo.vender_phone"
                :label="$t('Phone')"
                name="vender_phone"
                box
                hide-details
                background-color="white"
                :error="errors.has('vender_phone')"
              />
            </v-flex>

            <v-flex xs12 sm8 class="pa-2">
              <v-text-field
                v-model="supplierInfo.vender_mail"
                :label="$t('Email')"
                name="vender_mail"
                box
                hide-details
                background-color="white"
                autocomplete="off"
                :error="errors.has('vender_mail')"
                v-validate="'email'"
                data-vv-validate-on="blur"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pa-2">
              <v-autocomplete
                v-model="supplierInfo.vender_country"
                :items="countriesList"
                :label="`${$t('Country')}`"
                box
                hide-details
                browser-autocomplete
                background-color="white"
                :menu-props="{ transition: 'slide-y-transition' }"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pa-2">
              <v-text-field
                v-model="supplierInfo.vender_governorate"
                :label="$t('Governorate')"
                name="vender_governorate"
                box
                hide-details
                background-color="white"
                autocomplete="off"
                :error="errors.has('vender_governorate')"
              />
            </v-flex>

            <v-flex xs12 sm4 class="pa-2">
              <v-text-field
                v-model="supplierInfo.vender_city"
                :label="$t('City')"
                name="vender_city"
                box
                hide-details
                background-color="white"
                autocomplete="off"
                :error="errors.has('vender_city')"
              />
            </v-flex>

            <v-flex xs12 class="pa-2">
              <v-textarea
                v-model="supplierInfo.vender_address"
                :label="$t('Address')"
                name="vender_address"
                box
                hide-details
                height="80"
                background-color="white"
                :error="errors.has('vender_address')"
              />
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      btnUpdateLoading: false
    }
  },

  computed: {
    ...mapGetters({
      supplierInfo: 'suppliers/getSupplierInfo',
      supplierTypeList: 'suppliers/getSupplierTypeList',
      countriesList: 'locale/getCountriesList'
    })
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.addEscKeyListener()
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updateSupplierInfo: 'suppliers/updateSupplierInfo'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnUpdateLoading = true

          let formData = new FormData(event.target)
          formData.append('individual_or_company', this.supplierInfo.individual_or_company || '')
          formData.append('vender_country', this.supplierInfo.vender_country || '')

          // for (let pair of formData.entries()) {
          //   console.warn(`${pair[0]}: ${pair[1]}`)
          // }

          let payload = { id: this.supplierInfo.vender_id, formData }

          this.updateSupplierInfo(payload)
            .then(() => {
              this.btnUpdateLoading = false
              this.$emit('updated')
            })
            .catch(() => {
              this.btnUpdateLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped />
